/**
 * ./IconBubble/IconBubble.js
 *
 * - This component **renders a customizable speech bubble** with an optional **HTML icon or text** inside.
 * - Provides **positioning options** for the bubble's "carrot" (pointer).
 * 
 */

import React from "react";
import PropTypes from "prop-types";
import "./IconBubble.css";

function IconBubble({ width, height, HTML, position, color, fontSize }) {
  return (
    <div className="container">
      {position.includes("top") && (
        <div
          className={`bubble-carrot ${position}`}
          style={{ backgroundColor: `#${color}` }}
        ></div>
      )}
      <div
        className="bubble-container"
        style={{
          height: height,
          width: width,
          backgroundColor: `#${color}`,
          fontSize: fontSize,
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: HTML }} />
      </div>
      {position.includes("bottom") && (
        <div
          className={`bubble-carrot ${position}`}
          style={{ backgroundColor: `#${color}` }}
        ></div>
      )}
    </div>
  );
}

IconBubble.propTypes = {
  text: PropTypes.string.isRequired,
  position: PropTypes.oneOf([
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
  ]),
};

IconBubble.defaultProps = {
  width: 200,
  height: 100,
  position: "bottom-left",
  color: "bedfff",
  fontSize: 15,
};

export default IconBubble;
